export const WEEKDAY_NARROW_FORMAT_LOCALES = {
    ar: 'ar',
    el: 'el',
    he: 'he',
    pl: 'pl',
    vi: 'vi',
    zh: 'zh',
};
export const getFirstDayInMonth = (month) => {
    return new Date(month.getFullYear(), month.getMonth(), 1);
};
export const formatShortWeekDayName = (date, locale) => {
    const weekdayIntlFormat = WEEKDAY_NARROW_FORMAT_LOCALES[locale]
        ? 'narrow'
        : 'short';
    return new Intl.DateTimeFormat(locale, {
        weekday: weekdayIntlFormat,
    }).format(date);
};
export const formatLongWeekDayName = (date, locale) => {
    return new Intl.DateTimeFormat(locale, {}).format(date);
};
export const formatDay = (date, locale) => {
    return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
};
//# sourceMappingURL=dateUtils.js.map